<template>
    <Mobile v-if="isMobileSize" v-bind="$attrs" />
    <Pc v-else v-bind="$attrs" />
</template>

<script>
import Pc from './pc.vue';
import Mobile from './mobile.vue';
export default {
    name: 'CalendarSelect',
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    components: {
        Pc,
        Mobile
    }
};
</script>
